module.exports = __webpack_public_path__ + "img/img_01.a0e0fb0e.png";